<template>
    <div class="sd-subscription-page sd-sms-subscription">
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white pl-3">
                Dashboard
            </router-link>
            <router-link to="/school/subscription" class="text-white">
                <i class="fa fa-ellipsis-v px-2"></i>Subscription
            </router-link>
            <span class="text-white"> <i class="fa fa-ellipsis-v px-2"></i>SMS Subscription</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="sd-page-heading">
                <span class="sd-page-eyebrow">MESSAGING</span>
                <h1>SMS subscription</h1>
                <p>Choose a message volume to view its price and continue to secure checkout.</p>
            </div>
            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <div class="row">
                        <div class="col-lg-5">
                            <div class="card sd-sms-purchase-card border-0 mb-0">
                                <div class="card-body">
                                    <span class="sd-feature-icon"><i class="fa fa-envelope" aria-hidden="true"></i></span>
                                    <h2 class="sd-section-title">Find a package</h2>
                                    <p class="sd-section-copy">Enter the number of SMS units you need.</p>
                                    <div class="my-3">
                                        <base-input label="SMS units" @keyup="SearchSmsSuscription()" class="input-group-alternative"
                                            placeholder="Enter unit here..." addon-left-icon="fa fa-search"
                                            v-model="searchval">
                                        </base-input>
                                    </div>
                                    <p v-if="smsSearchLoading" class="sd-inline-status" role="status" aria-live="polite">
                                        <i class="fa fa-spinner fa-spin mr-1" aria-hidden="true"></i> Checking package price…
                                    </p>
                                    <div v-if="seachUnitVal" class="text-center">
                                        <div class="sd-price-panel">
                                            <span class="sd-page-eyebrow">PACKAGE TOTAL</span>
                                            <strong>{{ seachUnitVal }}</strong>
                                        </div>
                                        <button class="btn btn-primary sd-primary-action" @click="asyncPay">
                                            Continue to payment <i class="fa fa-arrow-right ml-1" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-7">
                            <section class="sd-rates-panel">
                                <div class="sd-rates-heading">
                                    <div>
                                        <h2 class="sd-section-title">SMS rates</h2>
                                        <p class="sd-section-copy">Compare available message volume and pricing.</p>
                                    </div>
                                    <span class="sd-neutral-badge"><i class="fa fa-list-alt mr-1" aria-hidden="true"></i> Packages</span>
                                </div>
                            <div class="table-responsive mt-2">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th scope="col">From units</th>
                                            <th scope="col">To units</th>
                                            <th scope="col">Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in smsUnitItems" :key="item.Id">
                                            <td class="sd-number">{{ item.Fromunit }}</td>
                                            <td class="sd-number">{{ item.ToUnit }}</td>
                                            <td class="sd-number sd-rate-price">{{ item.SMSPrice }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="smsUnitItems && !smsUnitItems.length" class="sd-empty-state">
                                <i class="fa fa-inbox" aria-hidden="true"></i>
                                <strong>No SMS packages available</strong>
                                <span>Please check back later.</span>
                            </div>
                            </section>
                        </div>
                    </div>
                </card>
            </div>

            <!-- End charts-->
        </div>
    </div>
</template>

<script>
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner"
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin"
export default {
    name: "reportcarsub",
    mixins: [Alert, CheckStaffUser],
    components: {
        PageSpinner
    },
    data() {
        return {
            seachUnitVal: '',
            searchval: "",
            smsSearchLoading: false,
            smsUnitItems: null,
            paymentItem: null,
            process: "N",
            onloader: "none",
            paymentData: {
                tx_ref: '',
                amount: 0,
                currency: "NGN",
                payment_options: "card,ussd",
                redirect_url: "https://schooldock.com/sms-subscription",
                customer: {
                    name: "",
                    email: "",
                    phone_number: ""
                },
                customizations: {
                    title: "SchoolDock",
                    description: "Report card subscription",
                    logo: "https://schooldock.com/img/brand/favicon.png"
                },
                callback: this.makePaymentCallback,
                onclose: this.closedPaymentModal
            }
        };
    },
    methods: {
        asyncPay() {
            this.asyncPayWithFlutterwave(this.paymentData).then(response => {
                console.log(response);
            });
        },
        makePaymentCallback(response) {
            console.log("Payment callback", response);
        },
        closedPaymentModal() {
            console.log("payment modal is closed");
        },
        populatePaymentData(TransRef, Amount, CustomerName, CustomerEmail, CustomerPhoneNo) {
            this.paymentData.tx_ref = TransRef
            this.paymentData.amount = Amount
            this.paymentData.customer.name = CustomerName
            this.paymentData.customer.email = CustomerEmail
            this.paymentData.customer.phone_number = CustomerPhoneNo
        },
        GetSmsType() {
            this.onloader = "flex";
            this.$store
                .dispatch("smsSub/GetSmsType")
                .then(resp => {
                    this.smsUnitItems = resp;
                    this.onloader = "none";
                })
                .catch(err => {
                    console.log(err);
                    this.onloader = "none";
                    this.$store.dispatch("logout");
                    this.$router.push("/home");
                });
        },
        SearchSmsSuscription() {
            if (this.searchval) {
                this.smsSearchLoading = true;
                this.$store
                    .dispatch("smsSub/SearchSmsSuscription", this.searchval)
                    .then(resp => {
                        this.populatePaymentData(resp.TransactionRef, resp.Amount, resp.CustormerName, resp.CustomerEmailAddress, resp.CustormerPhoneNo)
                        this.seachUnitVal = `${resp.TotalAmount}`;
                        localStorage.setItem("SmsUnit",this.searchval)
                    })
                    .catch(err => {
                        this.ShowAlertError(err.response && err.response.data || err.message || "Unable to check SMS package pricing.", '');
                    })
                    .finally(() => {
                        this.smsSearchLoading = false;
                    });
            } else {
                this.smsSearchLoading = false;
            }
        },
        ConfirmPayment() {
            let PaymentReference = this.$route.query.transaction_id;
            var SmsUnit=localStorage.getItem("SmsUnit");
            if (PaymentReference != null || PaymentReference != undefined) {
                let status = this.$route.query.status;
                if (status == "successful") {
                    this.onloader = "flex";
                  
                    this.$store
                        .dispatch("smsSub/ConfirmPayment", {PaymentReference,SmsUnit})
                        .then(() => {
                            this.onloader = "none";
                            this.ShowAlertSuccess("Submitted successfully", '');
                        })
                        .catch(err => {
                            this.onloader = "none";
                            console.log(err)
                        });
                }
            }
        },
    },
    mounted() {
        this.accessDetails = this.$store.getters['auth/_user'];
    if (this.accessDetails.isSchoolStaff == false) {
      this.$store.dispatch('auth/Logout')
      this.$router.push('/login')
    } else{
        this.ConfirmPayment()
        this.GetSmsType()
    }
        
    }
};
</script>

<style>
</style>
